<div class="learning-paths-widget">
  @if (paths?.length > 1 || title) {
    <div class="learning-paths-widget-header" [style.color]="textColor">
      <h4 class="paths-widget-title" [rtl]="langcode">
        {{ title }}
      </h4>
      @if (paths?.length > 1) {
        <div class="paths-pager">
          <button
            class="button button--icon button--transparent"
            mat-icon-button
            [disabled]="swiperComponent()?.swiper?.isBeginning"
            (click)="swiperComponent()?.swiper?.slidePrev()">
            <lib-icon icon="arrow-left"></lib-icon>
          </button>
          <div class="paths-pager-counter">
            {{swiperComponent()?.swiper?.activeIndex + 1}} / {{ paths?.length}}
          </div>
          <button
            class="button button--icon button--transparent"
            mat-icon-button
            [disabled]="swiperComponent()?.swiper?.isEnd"
            (click)="swiperComponent()?.swiper?.slideNext()">
            <lib-icon icon="arrow-right"></lib-icon>
          </button>
        </div>
      }
    </div>
  }

  <lib-swiper class="paths-swiper" [slides]="paths" [options]="carouselConfig()">
    <ng-template swiperContent let-item="item">
      <lib-learning-path-card
        #cardComponent
        class="learing-path-card"
        responsiveMode="container"
        [item]="item"
        (click)="navigateToPath.emit(item)"
        (onStart)="startPath.emit({ item: item, component: cardComponent })">
      </lib-learning-path-card>
    </ng-template>
  </lib-swiper>
</div>
